var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar3(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jar_3_svg__clip0_1961_6703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.58 133.65H71.02l-44.43 88.1a42.165 42.165 0 00-5.14 20.16v197.32c0 42.19 34.2 76.39 76.39 76.39H274.2c42.19 0 76.39-34.2 76.39-76.39V242.15c0-7.19-1.84-14.27-5.35-20.55l-46.66-87.95z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67 7.89h-147c-39.682 0-71.85 32.169-71.85 71.85v25.47c0 39.682 32.168 71.85 71.85 71.85h147c39.682 0 71.85-32.168 71.85-71.85V79.74c0-39.681-32.168-71.85-71.85-71.85z",
    fill: "#FD934F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.76 2.61H96.14c-32.883 0-59.54 26.655-59.54 59.535 0 32.88 26.657 59.535 59.54 59.535h171.62c32.883 0 59.54-26.655 59.54-59.535 0-32.88-26.657-59.535-59.54-59.535z",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87 424.16H68.18c-25.808 0-46.73 20.922-46.73 46.73 0 25.808 20.922 46.73 46.73 46.73h235.69c25.808 0 46.73-20.922 46.73-46.73 0-25.808-20.922-46.73-46.73-46.73z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 27.47,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.6 52.63h-80.35c-7.097 0-12.85 5.753-12.85 12.85v1.44c0 7.097 5.753 12.85 12.85 12.85h80.35c7.097 0 12.85-5.753 12.85-12.85v-1.44c0-7.097-5.753-12.85-12.85-12.85z",
    fill: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79 411.57H92.06c-16.105 0-29.16 13.055-29.16 29.16v15.82c0 16.104 13.055 29.16 29.16 29.16h188.73c16.105 0 29.16-13.056 29.16-29.16v-15.82c0-16.105-13.055-29.16-29.16-29.16z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.98 268.44v174.22c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V269.62l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18 290.18c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.37 373.09c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M225.37 337.81c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M225.37 302.54c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M225.37 408.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.13 268.44v174.22c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V269.62l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.33 290.18c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 373.09c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M145.53 337.81c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M145.53 302.54c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M145.53 408.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.37 358.8v83.94c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-82.76l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.57 375.13c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.77 380.64c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M301.77 411.06c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.99 266.55v-24.4c0-7.19-1.84-14.27-5.35-20.55l-9-16.97M294.99 395.48v-81.34",
    stroke: "#FBFDFE",
    strokeWidth: 21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.04 474.16c21.097 0 38.2-17.103 38.2-38.2 0-21.098-17.103-38.2-38.2-38.2s-38.2 17.102-38.2 38.2c0 21.097 17.103 38.2 38.2 38.2zM230.51 474.16c21.097 0 38.2-17.103 38.2-38.2 0-21.098-17.103-38.2-38.2-38.2s-38.2 17.102-38.2 38.2c0 21.097 17.103 38.2 38.2 38.2z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.85,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jar_3_svg__clip0_1961_6703"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h366.77v534.6H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar3);
export default ForwardRef;